module.exports = __webpack_public_path__ + "img/downimg_bg01.d33bdf02.png";